import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Select } from "../../../components/form";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useStockUnits } from "../hooks";

export const StockUnits: React.FC = () => {
  const navigate = useNavigate();
  const [inStock, setInStock] = useState<string>("true");

  const where: any = {};
  if (inStock) where.inStock = inStock === "true";

  const { data, loading } = useStockUnits({ where });

  return (
    <>
      <Header
        title="Lots en stock"
        subtitle="Traçabilité des lots par entrepôt"
        buttons={[
          {
            actionText: "Nouvelle réception",
            bgColor: "indigo",
            textColor: "white",
            link: `/stock-unit/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="card mb-4">
          <Select
            label="Statut"
            className="w-48"
            value={inStock}
            onChange={(e) => setInStock(e.target.value)}
          >
            <option value="true">En stock</option>
            <option value="false">Sorti</option>
            <option value="">Tous</option>
          </Select>
        </div>

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.stockUnits?.results?.length ? (
            <EmptyList text="Aucun lot" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Lot</TableCell>
                  <TableCell header>Produit</TableCell>
                  <TableCell header>Entrepôt</TableCell>
                  <TableCell header align="right">
                    Quantité
                  </TableCell>
                  <TableCell header align="center">
                    Statut
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.stockUnits?.results?.map((unit) => (
                  <TableRow
                    key={`stock-unit-${unit.id}`}
                    onClick={() => navigate(`/stock-unit/${unit.id}`)}
                  >
                    <TableCell>{unit.batchNumber}</TableCell>
                    <TableCell>{unit.product?.name}</TableCell>
                    <TableCell>{unit.warehouse?.name}</TableCell>
                    <TableCell align="right">{unit.quantity}</TableCell>
                    <TableCell align="center">
                      {unit.exitedAt ? "Sorti" : "En stock"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
